// =====================================================================
// Breadcrumbs.jsx - Reusable breadcrumb trail (Bonus B, Day 4)
// =====================================================================
// Folosit in pagini wrapper cu tabs (Trajets, Conges, Impressions,
// Prelevements, TempsPresence) ca sa afiseze context-ul curent.
//
// Props:
//   - items: Array<{ label: string, onClick?: () => void }>
//     - daca onClick prezent -> link clickable (text albastru)
//     - daca onClick absent  -> text simplu (ultimul, current page)
//
// Ex usage:
//   <Breadcrumbs items={[
//     { label: 'Trajets', onClick: () => setTab('trajets') },
//     { label: 'Facturation' },  // current
//   ]} />
// =====================================================================

export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav style={{
      display: 'flex', alignItems: 'center', flexWrap: 'wrap',
      gap: 6, fontSize: '0.8125rem', color: '#6b7280',
      marginBottom: '1rem',
    }} aria-label="Fil d'Ariane">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        const clickable = !!item.onClick && !isLast;

        return (
          <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {idx > 0 && (
              <span style={{ color: '#cbd5e1', fontSize: '0.875rem' }}>›</span>
            )}
            {clickable ? (
              <button
                onClick={item.onClick}
                style={{
                  background: 'transparent', border: 0, padding: 0,
                  color: '#2563eb', cursor: 'pointer',
                  fontSize: 'inherit', textDecoration: 'none',
                }}
                onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
              >
                {item.label}
              </button>
            ) : (
              <span style={{ color: isLast ? '#374151' : '#6b7280', fontWeight: isLast ? 500 : 400 }}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
